import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediastreamService {

  constructor() { }
}
